import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "url(#paint0_linear_1982_4261)",
      d: "M13.29 2.07q0 .258-.095.493a7 7 0 0 1-.242.53L8.266 12.82q-.266.531-.57.766-.298.242-.696.242-.39 0-.703-.242-.304-.235-.563-.766L1.047 3.094a26 26 0 0 1-.242-.54 1.3 1.3 0 0 1-.094-.491 1.1 1.1 0 0 1 .352-.829q.36-.336.984-.336l9.906.008q.625 0 .977.336.36.336.36.828"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "paint0_linear_1982_4261",
        x1: "-1",
        x2: "26.106",
        y1: "26.033",
        y2: "15.453",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#0085FF" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#67DBFC"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }